export type DashboardViewMode =
  | "my-loads"
  | "carrier-matches"
  | "lane-volume"
  | "risk-alerts"
  | "post-duplicates"
  | "market-intelligence";

export const VIEW_MODE_LABELS: Record<DashboardViewMode, string> = {
  "my-loads": "My Loads",
  "carrier-matches": "Carrier Matches",
  "lane-volume": "Lane Volume Insights",
  "risk-alerts": "Risk Alerts",
  "post-duplicates": "Post Duplication Suggestions",
  "market-intelligence": "Market Intelligence",
};
